import React from "react";
import { StarIcon, QuoteIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { SectionHeading } from "../SectionHeading";
import { testimonials } from "../../data/content";
export function TestimonialsSection() {
  return <section className="bg-navy px-4 py-16 sm:py-24" data-id="element-299" data-mp="1rtl51cydai8v">
      <div className="mx-auto max-w-6xl" data-id="element-300" data-mp="1mxcukcv47d81">
        <SectionHeading kicker="What professionals are saying" title="Dentists who brought structure to their reviews" data-id="element-301" data-mp="1muiawnjxdwfo" />

        <div className="mt-12 grid gap-5 md:grid-cols-2 md:gap-6" data-id="element-302" data-mp="1dvn4bacyykbu">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-white p-6 shadow-lg sm:p-8" data-id="element-303" data-mp="18w0iicj2rvrf">
              <div className="flex items-center justify-between" data-id="element-304" data-mp="13ys8iz82yy19">
                <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-305" data-mp="33akw658zar1b">
                  {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-gold text-gold" aria-hidden="true" data-id="element-306" data-mp="2yd1j38o0okay" data-mpi={i} />)}
                </div>
                <QuoteIcon className="h-8 w-8 text-brand/40" aria-hidden="true" data-id="element-307" data-mp="1tbzun3y3v92j" />
              </div>
              <blockquote className="mt-4 text-[17px] leading-relaxed text-navy" data-id="element-308" data-mp="1y6dlqu5qiu1e">"{t.quote}"</blockquote>
              <figcaption className="mt-auto flex items-center gap-4 pt-6" data-id="element-309" data-mp="1oakb5gbktam9">
                <img src={t.image} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-4 ring-brand/30" loading="lazy" data-id="element-310" data-mp="1ocmy1rhfmnmr" />
                <div data-id="element-311" data-mp="22ala2q8a67z3">
                  <p className="text-lg font-extrabold text-navy" data-id="element-312" data-mp="22b3faccx7wj5">{t.name}</p>
                  <p className="text-sm font-medium text-navy/60" data-id="element-313" data-mp="27950b2twq5x9">{t.role}</p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <div className="mt-12" data-id="element-314" data-mp="2uwwb21zsuawf">
          <CTAButton label="I want to review like them" sublabel="Join them today for just $27" data-id="element-315" data-mp="2zq8xc5h0a5m0" />
        </div>
      </div>
    </section>;
}